// Ideen unter /ideas/:slug, oeffentlich ohne Login (siehe publicRoutes).
//
// Hier teilen wir Konzepte mit Kunden, bevor sie im Produkt gebaut sind. Eine
// Idee ist eine eigenstaendige HTML-Datei in diesem Ordner. pages/idea.js
// rendert sie bildschirmfuellend in einem iframe.
//
// Warum kein public/: Amplify schreibt jede .html ausser der index.html per
// Rewrite-Regel auf die index.html um. Per `?raw` (craco.config.js) wird die
// Datei stattdessen ein eigener JS-Chunk, der nur auf dieser Route laedt.
//
// localStorage: das iframe teilt sich den Origin mit dem Dashboard. Keys in
// den HTML-Dateien deshalb immer mit `aivy-idea:<slug>:` prefixen.
//
// Die Seiten sind ohne Login abrufbar und bekommen noindex. Keine Kundendaten
// und nichts Internes in die Dateien schreiben.
export const IDEAS = [
  {
    slug: 'kulturprofil-team',
    title: 'Kulturprofil im Team festlegen',
    load: () => import('./kulturprofil-team.html?raw')
  }
]

export const findIdea = (slug) => IDEAS.find((idea) => idea.slug === slug)
